import { render, staticRenderFns } from "./DownloadFileBtns.vue?vue&type=template&id=2ce69182&scoped=true&"
import script from "./DownloadFileBtns.vue?vue&type=script&lang=js&"
export * from "./DownloadFileBtns.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFileBtns.vue?vue&type=style&index=0&id=2ce69182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce69182",
  null
  
)

export default component.exports